import {stage} from 'constants/url';
import useUpdate from '../../../components/hooks/useUpdate';
import {EditingOptions} from '../../../components/grid-dx/types';

function useUpdateStage() {
  const updateStage = useUpdate(stage);
  return (editingOptions: EditingOptions) => updateStage(editingOptions);
}

export default useUpdateStage;
